import { OmnichannelChatSDK } from '@microsoft/omnichannel-chat-sdk';
import ChatConfig from '@microsoft/omnichannel-chat-sdk/lib/core/ChatConfig';
import { ILiveChatWidgetProps } from '@microsoft/omnichannel-chat-widget/lib/types/components/livechatwidget/interfaces/ILiveChatWidgetProps';
import { ccsChatLocalisedTexts } from './ccs-chat-localised-texts';
import {
  webChatContainerProps,
  headerProps,
  footerProps,
  telemetryConfig,
  outOfOfficeHoursProps,
} from './get-chat-widget-props';

type ChatLocale = 'en' | 'fr';

export const getLiveChatWidgetPropsDesktop = (
  chatConfig: ChatConfig,
  chatLocale: ChatLocale,
  sdkChat: OmnichannelChatSDK,
): ILiveChatWidgetProps => {
  const {
    LOADINGPANE_TITLE_TEXT,
    LOADINGPANE_SUBTITLE_TEXT,
    LOADINGPANE_SPINNER_TEXT,
  } = ccsChatLocalisedTexts(chatLocale).loadingPaneTexts;

  return {
    chatConfig,
    chatSDK: sdkChat,
    confirmationPaneProps: {
      confirmationPaneLocalizedTexts: {
        CLOSE_CONFIRMATION_DIALOG_TITLE_DEFAULT:
          ccsChatLocalisedTexts(chatLocale).dialogOptions
            .CLOSE_CONFIRMATION_DIALOG_TITLE,
        CLOSE_CONFIRMATION_DIALOG_DESCRIPTION_DEFAULT:
          ccsChatLocalisedTexts(chatLocale).dialogOptions
            .CLOSE_CONFIRMATION_DIALOG_DESCRIPTION,
      },
    },
    controlProps: {
      // ASYNC_CHAT_TODO: CD-161 Look into accessibility friendly option
      hideFooter: false, // library_bug?: without the footer we don't get notification sounds - hidden with css instead
      hideChatButton: true,
      hideStartChatButton: true,
      widgetInstanceId: 'widget1',
    },
    outOfOfficeHoursPaneProps: outOfOfficeHoursProps(chatConfig),
    footerProps,
    headerProps: {
      controlProps: {
        ...headerProps(chatLocale).controlProps,
        headerTitleProps: {
          text: ccsChatLocalisedTexts(chatLocale).headerControlProps
            .HEADER_TEXT,
        },
      },
      componentOverrides: {
        ...headerProps(chatLocale).componentOverrides,
      },
    },
    loadingPaneProps: {
      controlProps: {
        titleText: LOADINGPANE_TITLE_TEXT,
        subtitleText: LOADINGPANE_SUBTITLE_TEXT,
        spinnerText: LOADINGPANE_SPINNER_TEXT,
      },
    },
    styleProps: {
      generalStyles: {
        width: '100%',
        height: '100%',
      },
    },
    telemetryConfig,
    webChatContainerProps,
  };
};

export const getLiveChatWidgetPropsMobile = (
  chatConfig: ChatConfig,
  chatLocale: string,
  sdkChat: OmnichannelChatSDK,
): ILiveChatWidgetProps => {
  const {
    LOADINGPANE_TITLE_TEXT,
    LOADINGPANE_SUBTITLE_TEXT,
    LOADINGPANE_SPINNER_TEXT,
  } = ccsChatLocalisedTexts(chatLocale).loadingPaneTexts;
  return {
    chatConfig,
    chatSDK: sdkChat,
    controlProps: {
      hideStartChatButton: true, // renamed from skipChatButtonRendering in previous versions
      widgetInstanceId: 'widget1',
    },
    outOfOfficeHeaderProps: {
      controlProps: {
        hideMinimizeButton: true,
      },
    },
    outOfOfficeHoursPaneProps: outOfOfficeHoursProps(chatConfig),
    footerProps,
    headerProps: {
      ...headerProps(chatLocale),
      controlProps: {
        hideMinimizeButton: true,
        hideCloseButton: true,
        headerTitleProps: {
          text: ccsChatLocalisedTexts(chatLocale).headerControlProps
            .HEADER_TEXT,
        },
      },
    },
    loadingPaneProps: {
      controlProps: {
        titleText: LOADINGPANE_TITLE_TEXT,
        subtitleText: LOADINGPANE_SUBTITLE_TEXT,
        spinnerText: LOADINGPANE_SPINNER_TEXT,
      },
    },
    styleProps: {
      generalStyles: {
        width: '100%',
        height: '100%',
      },
    },
    telemetryConfig,
    webChatContainerProps,
  };
};
